(() => {
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let toastTimer;
  let currentCart = null;
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
  function toast(message) {
    const box = document.getElementById('ign-toast');
    if (!box) return;
    box.textContent = message || document.body.dataset.error;
    box.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => box.classList.remove('show'), 5000);
  }
  function setBusy(value) {
    busy = value;
    document.querySelectorAll('#cart-form button, #cart-form input, .quick-add button, form[action*="/cart/add"] button').forEach(element => {
      if (value) {
        element.dataset.ignDisabled = element.disabled ? 'true' : 'false';
        element.disabled = true;
      } else {
        if (element.dataset.ignDisabled !== undefined) element.disabled = element.dataset.ignDisabled === 'true';
        delete element.dataset.ignDisabled;
      }
    });
    document.getElementById('cart-form')?.setAttribute('aria-busy', String(value));
  }
  function syncCart(cart) {
    currentCart = cart;
    document.querySelectorAll('[data-cart-count]').forEach(element => element.textContent = cart.item_count);
    document.querySelectorAll('[data-cart-total]').forEach(element => element.textContent = money(cart.total_price, cart.currency));
    document.querySelectorAll('#cart-form input[data-line]').forEach(input => {
      const item = cart.items[Number(input.dataset.line) - 1];
      if (!item) return;
      input.dataset.key = item.key;
      input.dataset.savedQuantity = String(item.quantity);
      input.value = item.quantity;
    });
  }
  async function cartRefresh() {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(document.body.dataset.error);
    const cart = await response.json();
    syncCart(cart);
    return cart;
  }
  function cartSectionId() {
    return document.getElementById('cart-form')?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '') || null;
  }
  async function renderCart(cart, sectionId) {
    if (!sectionId) return;
    let html = cart.sections?.[sectionId];
    if (!html) {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(document.body.dataset.error);
      html = await response.text();
    }
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const wrapperId = 'shopify-section-' + sectionId;
    const replacement = parsed.getElementById(wrapperId);
    const existing = document.getElementById(wrapperId);
    if (!replacement || !existing) throw new Error(document.body.dataset.error);
    existing.replaceWith(replacement);
    syncCart(cart);
  }
  function quantity(input) {
    const min = Number.isFinite(Number(input.min)) ? Number(input.min) : 1;
    const max = input.max ? Number(input.max) : Infinity;
    const value = Number(input.value);
    return Math.min(max, Math.max(min, Number.isFinite(value) ? Math.trunc(value) : min));
  }
  async function changeCart(input) {
    if (busy) return;
    const requested = quantity(input);
    const saved = Number(input.dataset.savedQuantity);
    if (input.dataset.savedQuantity !== undefined && requested === saved) {
      input.value = saved;
      return;
    }
    const focusId = input.id;
    const sectionId = cartSectionId();
    const subtotalLabel = document.querySelector(".cart-summary h2")?.textContent || "";
    let key = input.dataset.key;
    setBusy(true);
    try {
      if (!key) {
        const cart = await cartRefresh();
        key = cart.items[Number(input.dataset.line) - 1]?.key;
      }
      if (!key) throw new Error(document.body.dataset.error);
      const body = { id: key, quantity: requested };
      if (sectionId) {
        body.sections = [sectionId];
        body.sections_url = window.location.pathname + window.location.search;
      }
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const cart = await response.json();
      if (!response.ok || cart.status >= 400) throw new Error(cart.description || cart.message || document.body.dataset.error);
      syncCart(cart);
      await renderCart(cart, sectionId);
      toast(subtotalLabel + ": " + money(cart.total_price, cart.currency));
      (document.getElementById(focusId) || document.querySelector('.empty-state a.button'))?.focus({ preventScroll: true });
    } catch (error) {
      try {
        const cart = await cartRefresh();
        await renderCart(cart, sectionId);
      } catch {
        if (input.dataset.savedQuantity !== undefined) input.value = input.dataset.savedQuantity;
        window.location.reload();
      }
      toast(error.message || document.body.dataset.error);
    } finally {
      setBusy(false);
    }
  }
  async function addProduct(form) {
    if (busy || document.body.dataset.ordering !== 'true') return;
    const body = new FormData(form);
    setBusy(true);
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || document.body.dataset.error);
      await cartRefresh();
      toast(document.body.dataset.added);
    } catch (error) {
      try { await cartRefresh(); } catch {}
      toast(error.message || document.body.dataset.error);
    } finally {
      setBusy(false);
    }
  }
  document.addEventListener('click', event => {
    const remove = event.target.closest('#cart-form .remove');
    if (remove) {
      event.preventDefault();
      if (busy) return;
      const input = remove.closest('.cart-row')?.querySelector('input[data-line]');
      if (input) { input.value = 0; changeCart(input); }
      return;
    }
    const button = event.target.closest('[data-step]');
    if (!button || busy) return;
    const input = button.closest('.quantity-control')?.querySelector('input');
    if (!input) return;
    input.value = Number(input.value || 0) + Number(button.dataset.step);
    input.value = quantity(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('#cart-form input[data-line]')) changeCart(input);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('.zip-form')) {
      event.preventDefault();
      const zip = form.querySelector('input').value.trim();
      if (!/^\d{5}$/.test(zip)) return;
      const output = form.querySelector('.zip-result');
      output.textContent = output.dataset.message;
      try { sessionStorage.setItem('ign-interest-zip', zip); } catch {}
      return;
    }
    if (form.id === 'cart-form') {
      if (busy) event.preventDefault();
      return;
    }
    if (form.matches('.quick-add') || /\/cart\/add\/?$/.test(new URL(form.action, window.location.href).pathname)) {
      event.preventDefault();
      addProduct(form);
    }
  });
  if (document.getElementById('cart-form')) {
    setBusy(true);
    cartRefresh().catch(() => toast(document.body.dataset.error)).finally(() => setBusy(false));
  }
})();